import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

// Selectors
const getMaterialLayer = path(["domain", "ui", "materialLayer"]);
export const selectMaterialLayer = createSelector(getMaterialLayer, identity);
export const selectIsMaterialLayerEnabled = createSelector(
  getMaterialLayer,
  prop("isEnabled")
);

// Initial State
const initialState = () => ({
  isEnabled: true
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
